exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container_from_Configuration-css_1n4 {\n  width: 100%;\n  padding: 0 32px;\n  margin: 52px auto;\n  max-width: 624px;\n}\n\n.fieldWrapper_from_Configuration-css_1r- {\n  position: relative;\n}\n\n.fieldLabel_from_Configuration-css_3og {\n  display: block;\n  width: 100%;\n  font-size: 0.8em;\n  font-weight: 600;\n  color: #373347;\n  margin: 0;\n  margin-top: 32px;\n  padding-bottom: 8px;\n}\n\n.fieldGroup_from_Configuration-css_1C5 {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n", ""]);

// exports
exports.locals = {
	"container": "container_from_Configuration-css_1n4",
	"fieldWrapper": "fieldWrapper_from_Configuration-css_1r-",
	"fieldLabel": "fieldLabel_from_Configuration-css_3og",
	"fieldGroup": "fieldGroup_from_Configuration-css_1C5"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/admin/Configuration.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/admin/Configuration.css
// module chunks = 0